import { createTheme } from "@mui/material";
import { orange } from "@mui/material/colors";

// primary theme
export const primaryTheme = createTheme({
    palette: {
        mode: 'light',
        primary: orange
    },
    typography: {
        fontFamily: 'Raleway',
    },
})

// dark mode theme